import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['navLink']

  static values = { turboFrame: String }

  connect() {
    if (!this.turboFrameValue) return

    this.boundOnNavigate = this.onNavigate.bind(this)

    window.addEventListener('turbo:before-fetch-request', this.boundOnNavigate)
  }

  disconnect() {
    if (!this.turboFrameValue) return

    window.removeEventListener(
      'turbo:before-fetch-request',
      this.boundOnNavigate
    )
  }

  onNavigate(event) {
    if (event.target.id !== this.turboFrameValue) return

    this.navLinkTargets.forEach((link) =>
      this.toggleActive(link, event.detail.url.href)
    )
  }

  toggleActive(link, url) {
    const active = link.href === url

    link.classList.toggle('active', active)
    link.classList.toggle('opacity-20', !active)
  }
}
